import { render, staticRenderFns } from "./OneProgram.vue?vue&type=template&id=4b22a4e9&"
import script from "./OneProgram.vue?vue&type=script&lang=js&"
export * from "./OneProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports